module.exports = __webpack_public_path__ + "static/img/female-bg-en.9b0f18e4.png";